import axios from "axios";

export default axios.create({
    baseURL: 'https://wmt.cloud.sysco.com'
})
